import { useEffect } from "react";
import { Modal, Form as FormLayout } from "react-bootstrap";
import { useUpdateUserStatusMutation } from "../../../../../../../../redux/apiSlice";
import cogoToast from "cogo-toast";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import SelectInput from "../../../../../../Common/components/select-input";

export const ChangeUserStatusModal = ({ showChangeUserStatusModal, onHide, details }) => {
    const [
        changeUserStatus, // This is the mutation trigger
        {
            isLoading: isChanging,
            isSuccess: changedSuccessfully,
        }, // This is the destructured mutation result
    ] = useUpdateUserStatusMutation()

    /* Close Modal on Successful Deletion */
    useEffect(() => {
        if (changedSuccessfully) {
            cogoToast.success("Created 'Change Status' Action Successfully")
            onHide()
        }
    }, [changedSuccessfully, onHide]);

    /* Change User Group */
    const onSubmit = (values) => {
        const normalizedStatus = `${values?.status ?? ""}`.trim().toUpperCase();
        changeUserStatus({
            userId: details?.basic?.userId,
            username: details?.basic?.username,
            status: normalizedStatus,
            // reason: normalizedStatus === "DISABLED" ? values?.reason?.trim() : values?.reason?.trim() || undefined,
            meta: { status: details?.basic?.status },
        });
    };

    return (
        <Modal
            show={showChangeUserStatusModal}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={isChanging ? "static" : true}
            keyboard={!isChanging}
        >
            <Formik
                initialValues={{
                    status: `${details?.basic?.status ?? ""}`.trim().toUpperCase(),
                    // reason: "",
                }}
                validationSchema={
                    Yup.object({
                        status: Yup.string().required("required"),
                        // reason: Yup.string().when("status", {
                        //     is: "DISABLED",
                        //     then: Yup.string().trim().required("Disable reason is required"),
                        //     otherwise: Yup.string().trim(),
                        // }),
                    })
                }
                onSubmit={onSubmit}
            >
                {() => (
                <Form>
                    <Modal.Header>
                        <Modal.Title id="contained-modal-title-vcenter">
                            {`Change ${details?.basic?.username}'s Status`}
                        </Modal.Title>
                        <button type="button" className="close" onClick={onHide}>
                            <span aria-hidden="true" className="d-block">×</span>
                            <span className="sr-only">Close</span>
                        </button>
                    </Modal.Header>

                    <Modal.Body style={{ maxHeight: "calc(100vh - 300px)", overflow: "auto" }}>
                        <FormLayout.Row>
                            <SelectInput
                                label="Select Status*"
                                name="status"
                                options={[
                                    { name: "Pending", value: "PENDING" },
                                    { name: "Verified", value: "VERIFIED" },
                                    { name: "Disabled", value: "DISABLED" },
                                    { name: "Deleted", value: "DELETED" },
                                ]}
                            />
                        </FormLayout.Row>
                        {/* Old reason-based disable flow kept here for reference.
                        {values?.status === "DISABLED" && (
                            <FormLayout.Group>
                                <FormLayout.Label>Disable Reason*</FormLayout.Label>
                                <FormLayout.Control
                                    as="textarea"
                                    rows={4}
                                    name="reason"
                                    value={values?.reason}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder="Enter the reason for disabling this user"
                                    isInvalid={Boolean(touched?.reason && errors?.reason)}
                                />
                                {touched?.reason && errors?.reason ? (
                                    <div className="text-danger mt-2">{errors.reason}</div>
                                ) : null}
                            </FormLayout.Group>
                        )} */}
                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            type="button"
                            onClick={onHide}
                            disabled={isChanging}
                            className="btn btn-light btn-elevate px-4"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={isChanging}
                            className="btn btn-primary btn-elevate px-4 ml-4"
                        >
                            Submit
                        </button>
                    </Modal.Footer>
                </Form>
                )}
            </Formik>
        </Modal>
    );
};
